var _g, _g2, _g3, _g4, _g5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebappOoops(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1242.124px",
    height: "600px",
    viewBox: "0 0 1242.124 600",
    enableBackground: "new 0 0 1242.124 600",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 744.1475,
    y1: -311.1494,
    x2: 1044.2529,
    y2: 208.6485
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00385D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#336FB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7414,
    style: {
      stopColor: "#3397E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    style: {
      stopColor: "#B1D7F3"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M906.584,104h134c9.916,0,17.983-7.838,17.983-17.752c0-9.918-8.067-17.755-17.983-17.755 l-134-0.115c-9.917,0-17.984,7.952-17.984,17.87C888.6,96.162,896.667,104,906.584,104z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 751.1211,
    y1: -541.5566,
    x2: 1153.2434,
    y2: 154.9398
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00385D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#336FB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7414,
    style: {
      stopColor: "#3397E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    style: {
      stopColor: "#B1D7F3"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M1107.584,104h12c9.916,0,17.983-7.838,17.983-17.752c0-9.918-8.067-17.755-17.983-17.755 l-12-0.115c-9.917,0-17.984,7.952-17.984,17.87C1089.6,96.162,1097.667,104,1107.584,104z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 685.9531,
    y1: -458.8936,
    x2: 1091.0194,
    y2: 242.702
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00385D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#336FB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7414,
    style: {
      stopColor: "#3397E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    style: {
      stopColor: "#B1D7F3"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M1002.6,130.23c0,9.916,8.067,17.77,17.984,17.77h11c9.916,0,17.983-7.854,17.983-17.77 s-8.067-17.771-17.983-17.771l-11-0.106C1010.667,112.354,1002.6,120.314,1002.6,130.23z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 803.8242,
    y1: -300.8174,
    x2: 1103.7566,
    y2: 218.6808
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00385D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#336FB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7414,
    style: {
      stopColor: "#3397E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    style: {
      stopColor: "#B1D7F3"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M992.6,174.214c0,9.916,8.067,17.786,17.984,17.786h135c9.916,0,17.983-7.87,17.983-17.786 s-8.067-17.787-17.983-17.787l-135-0.099C1000.667,156.328,992.6,164.298,992.6,174.214z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 697.6641,
    y1: -283.9756,
    x2: 1038.8359,
    y2: 306.9516
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00385D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#336FB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7414,
    style: {
      stopColor: "#3397E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    style: {
      stopColor: "#B1D7F3"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_8_)",
    d: "M943.6,218.181c0,9.916,8.067,18.179,17.984,18.179l52-0.098c9.916,0,17.983-8.165,17.983-18.081 c0-9.917-8.067-18.181-17.983-18.181h-52C951.667,200,943.6,208.264,943.6,218.181z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 784.8398,
    y1: -310.6963,
    x2: 1116.0024,
    y2: 262.8943
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00385D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#336FB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7414,
    style: {
      stopColor: "#3397E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    style: {
      stopColor: "#B1D7F3"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_10_)",
    d: "M1146.584,244.277c9.916,0,17.983,7.986,17.983,17.903c0,9.916-8.067,17.819-17.983,17.819h-62 c-9.917,0-17.984-7.903-17.984-17.819c0-9.917,8.067-17.821,17.984-17.821L1146.584,244.277z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 633.543,
    y1: -441.3408,
    x2: 1080.6987,
    y2: 333.1557
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00385D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#336FB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7414,
    style: {
      stopColor: "#3397E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    style: {
      stopColor: "#B1D7F3"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_11_)",
    d: "M1072.6,350.277c0,9.916,8.067,17.982,17.984,17.982c9.916,0,17.983-8.066,17.983-17.982 c0-9.917-8.067-17.984-17.983-17.984C1080.667,332.293,1072.6,340.36,1072.6,350.277z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 683.0352,
    y1: -98.2422,
    x2: 1010.6268,
    y2: 469.1632
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00385D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#336FB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7414,
    style: {
      stopColor: "#3397E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    style: {
      stopColor: "#B1D7F3"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_12_)",
    d: "M1070.567,482.08c0-9.916-8.067-18.08-17.983-18.08h-69c-9.917,0-17.984,8.164-17.984,18.08 s8.067,18.079,17.984,18.079l69-0.048C1062.5,500.111,1070.567,491.996,1070.567,482.08z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 520.9463,
    y1: -18.1016,
    x2: 882.9966,
    y2: 608.9882
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00385D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#336FB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7414,
    style: {
      stopColor: "#3397E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    style: {
      stopColor: "#B1D7F3"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_13_)",
    d: "M851.584,508h-33c-9.917,0-17.984,8.084-17.984,18.001c0,9.915,8.067,17.999,17.984,17.999h33 c9.916,0,17.983-8.084,17.983-17.999C869.567,516.084,861.5,508,851.584,508z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 626.3232,
    y1: -32.1719,
    x2: 955.6221,
    y2: 538.1906
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00385D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#336FB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7414,
    style: {
      stopColor: "#3397E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    style: {
      stopColor: "#B1D7F3"
    }
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_14_)",
    d: "M981.584,508h-66c-9.917,0-17.984,8.084-17.984,18.001c0,9.915,8.067,17.999,17.984,17.999h66 c9.916,0,17.983-8.084,17.983-17.999C999.567,516.084,991.5,508,981.584,508z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 302.0898,
    y1: -15.084,
    x2: 656.1535,
    y2: 598.1724
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00385D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#336FB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7414,
    style: {
      stopColor: "#3397E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    style: {
      stopColor: "#B1D7F3"
    }
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_15_)",
    d: "M340.584,104.46l40-0.123c9.916,0,17.983-8.19,17.983-18.106S390.5,68,380.584,68h-40 c-9.916,0-17.984,8.314-17.984,18.23S330.668,104.46,340.584,104.46z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.7354,
    y1: 143.4668,
    x2: 461.5522,
    y2: 683.5495
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00385D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#336FB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7414,
    style: {
      stopColor: "#3397E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    style: {
      stopColor: "#B1D7F3"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_16_)",
    d: "M91.584,148.427l101-0.115c9.916,0,17.983-8.183,17.983-18.097 c0-9.918-8.067-18.215-17.983-18.215h-101c-9.916,0-17.984,8.297-17.984,18.215C73.6,140.129,81.668,148.427,91.584,148.427z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 188.3467,
    y1: 130.4844,
    x2: 552.9697,
    y2: 762.03
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00385D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#336FB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7414,
    style: {
      stopColor: "#3397E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    style: {
      stopColor: "#B1D7F3"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_17_)",
    d: "M229.584,192.286c9.916,0,17.983-8.173,17.983-18.089S239.5,156,229.584,156h-32 c-9.916,0-17.984,8.281-17.984,18.197s8.068,18.195,17.984,18.195L229.584,192.286z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 94.168,
    y1: 244.3057,
    x2: 486.7567,
    y2: 924.2894
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00385D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#336FB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7414,
    style: {
      stopColor: "#3397E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    style: {
      stopColor: "#B1D7F3"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_18_)",
    d: "M105.567,218.181c0-9.917-8.067-18.181-17.983-18.181h-17c-9.916,0-17.984,8.264-17.984,18.181 c0,9.916,8.068,18.179,17.984,18.179l17-0.098C97.5,236.262,105.567,228.097,105.567,218.181z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.8809,
    y1: 235.8311,
    x2: 475.4046,
    y2: 846.4201
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00385D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#336FB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7414,
    style: {
      stopColor: "#3397E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    style: {
      stopColor: "#B1D7F3"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_19_)",
    d: "M99.6,262.164c0,9.916,8.068,18.162,17.984,18.162l41-0.09c9.916,0,17.983-8.156,17.983-18.072 c0-9.917-8.067-18.164-17.983-18.164h-41C107.668,244,99.6,252.247,99.6,262.164z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.6885,
    y1: 294.2197,
    x2: 404.887,
    y2: 848.8198
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00385D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#336FB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7414,
    style: {
      stopColor: "#3397E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    style: {
      stopColor: "#B1D7F3"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_20_)",
    d: "M131.584,324c9.916,0,17.983-7.92,17.983-17.836c0-9.917-8.067-17.838-17.983-17.838l-80-0.073 c-9.916,0-17.984,7.994-17.984,17.911C33.6,316.08,41.668,324,51.584,324H131.584z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.6338,
    y1: 312.9902,
    x2: 519.7896,
    y2: 1087.4868
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00385D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#336FB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7414,
    style: {
      stopColor: "#3397E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    style: {
      stopColor: "#B1D7F3"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_21_)",
    d: "M75.6,349.277c0,9.916,8.068,17.982,17.984,17.982s17.983-8.066,17.983-17.982 c0-9.917-8.067-17.984-17.983-17.984S75.6,339.36,75.6,349.277z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.4502,
    y1: 266.5762,
    x2: 529.0245,
    y2: 937.8746
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00385D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#336FB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7414,
    style: {
      stopColor: "#3397E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    style: {
      stopColor: "#B1D7F3"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_22_)",
    d: "M205.584,412.227l19-0.064c9.916,0,17.983-8.132,17.983-18.048 c0-9.917-8.067-18.114-17.983-18.114h-19c-9.916,0-17.984,8.197-17.984,18.114C187.6,404.03,195.668,412.227,205.584,412.227z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 101.5195,
    y1: 355.7119,
    x2: 420.0475,
    y2: 907.4187
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00385D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#336FB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7414,
    style: {
      stopColor: "#3397E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    style: {
      stopColor: "#B1D7F3"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_23_)",
    d: "M209.567,438.097c0-9.916-8.067-18.097-17.983-18.097h-85c-9.916,0-17.984,8.181-17.984,18.097 c0,9.915,8.068,18.096,17.984,18.096l85-0.057C201.5,456.136,209.567,448.012,209.567,438.097z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 140.6289,
    y1: 326.2734,
    x2: 496.3726,
    y2: 942.4396
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00385D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#336FB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7414,
    style: {
      stopColor: "#3397E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    style: {
      stopColor: "#B1D7F3"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_24_)",
    d: "M267.567,482.08c0-9.916-8.067-18.08-17.983-18.08h-38c-9.916,0-17.984,8.164-17.984,18.08 s8.068,18.079,17.984,18.079l38-0.048C259.5,500.111,267.567,491.996,267.567,482.08z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.5889,
    y1: 345.0713,
    x2: 499.2012,
    y2: 865.7472
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00385D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#336FB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7414,
    style: {
      stopColor: "#3397E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    style: {
      stopColor: "#B1D7F3"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_25_)",
    d: "M370.584,508h-135c-9.916,0-17.984,8.146-17.984,18.064c0,9.914,8.068,18.062,17.984,18.062 l135-0.04c9.916,0,17.983-8.107,17.983-18.021C388.567,516.146,380.5,508,370.584,508z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.4023,
    y1: 389.7832,
    x2: 473.7943,
    y2: 1095.4067
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00385D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#336FB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7414,
    style: {
      stopColor: "#3397E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    style: {
      stopColor: "#B1D7F3"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_26_)",
    d: "M150.584,508h-11c-9.916,0-17.984,8.146-17.984,18.064c0,9.914,8.068,18.062,17.984,18.062 l11-0.04c9.916,0,17.983-8.107,17.983-18.021C168.567,516.146,160.5,508,150.584,508z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 402.7754,
    y1: 32.6426,
    x2: 735.7587,
    y2: 609.3867
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00385D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#336FB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7414,
    style: {
      stopColor: "#3397E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    style: {
      stopColor: "#B1D7F3"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_27_)",
    d: "M939.584,417h-66c-12.142,0-21.984-10.198-21.984-22.338c0-12.143,9.843-22.34,21.984-22.34 l132,0.114c12.141,0,21.983-9.665,21.983-21.806c0-12.143-9.843-21.631-21.983-21.631h-154c-12.142,0-21.984-10.164-21.984-22.305 c0-12.143,9.843-22.307,21.984-22.307l88,0.098c12.141,0,21.983-9.682,21.983-21.822c0-12.143-9.843-21.664-21.983-21.664h-66 c-12.142,0-21.984-10.131-21.984-22.271c0-12.142,9.843-22.273,21.984-22.273l44,0.081c12.141,0,21.983-9.698,21.983-21.839 c0-12.143-9.843-21.697-21.983-21.697h-154c-12.142,0-21.984-10.098-21.984-22.238c0-12.143,9.843-22.239,21.984-22.239l77,0.064 c12.141,0,21.983-9.716,21.983-21.856c0-12.143-9.843-21.73-21.983-21.73h-379c-12.142,0-21.984,9.588-21.984,21.73 c0,12.141,9.843,21.729,21.984,21.729l22,0.144c12.141,0,21.983,9.984,21.983,22.127c0,12.141-9.843,22.27-21.983,22.27h-154 c-12.142,0-21.984,9.586-21.984,21.729c0,12.141,9.843,21.727,21.984,21.727l44,0.098c12.141,0,21.983,10.003,21.983,22.145 c0,12.141-9.843,22.303-21.983,22.303h-143c-12.142,0-21.984,9.553-21.984,21.695c0,12.141,9.843,21.693,21.984,21.693l66,0.114 c12.141,0,21.983,10.019,21.983,22.161c0,12.141-9.843,22.336-21.983,22.336h-143c-12.142,0-21.984,9.52-21.984,21.662 c0,12.141,9.843,21.66,21.984,21.66l209,0.131c12.141,0,21.983,10.035,21.983,22.178c0,12.14-9.843,22.369-21.983,22.369h-110 c-12.142,0-21.984,9.486-21.984,21.628c0,12.141,9.843,21.627,21.984,21.627l198,0.147c12.141,0,21.983,10.053,21.983,22.195 c0,12.141-9.843,22.402-21.983,22.402h-22c-12.142,0-21.984,9.453-21.984,21.596c0,12.141,9.843,21.593,21.984,21.593l335,0.147 c12.141,0,21.983-9.631,21.983-21.771c0-12.143-9.843-21.564-21.983-21.564h-55c-12.142,0-21.984-10.23-21.984-22.371 c0-12.143,9.843-22.374,21.984-22.374l231,0.131c12.141,0,21.983-9.648,21.983-21.789C961.567,426.455,951.725,417,939.584,417z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 502.023,
    y1: 167.387,
    x2: 527.562,
    y2: 192.924
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 502.969,
    y1: 191.979,
    x2: 527.562,
    y2: 167.387
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 775.022,
    y1: 418.387,
    x2: 800.562,
    y2: 443.924
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 775.968,
    y1: 442.979,
    x2: 800.562,
    y2: 418.387
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 649.022,
    y1: 88.387,
    x2: 674.562,
    y2: 113.924
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 649.968,
    y1: 112.979,
    x2: 674.562,
    y2: 88.387
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 382.348,
    y1: 157.997,
    x2: 399.938,
    y2: 175.586
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 383,
    y1: 174.936,
    x2: 399.938,
    y2: 157.997
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 112.348,
    y1: 422.997,
    x2: 129.938,
    y2: 440.586
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 113,
    y1: 439.936,
    x2: 129.938,
    y2: 422.997
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 331.348,
    y1: 72.997,
    x2: 348.938,
    y2: 90.586
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 332,
    y1: 89.936,
    x2: 348.938,
    y2: 72.997
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 509.913,
    y1: 434.86,
    x2: 519.535,
    y2: 444.482
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 510.27,
    y1: 444.126,
    x2: 519.535,
    y2: 434.86
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 447.913,
    y1: 507.86,
    x2: 457.535,
    y2: 517.482
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 448.27,
    y1: 517.126,
    x2: 457.535,
    y2: 507.86
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 432.941,
    y1: 526.889,
    x2: 445.666,
    y2: 539.612
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 433.412,
    y1: 539.141,
    x2: 445.666,
    y2: 526.889
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 390.913,
    y1: 390.86,
    x2: 400.535,
    y2: 400.482
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 391.27,
    y1: 400.126,
    x2: 400.535,
    y2: 390.86
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 298.913,
    y1: 344.86,
    x2: 308.535,
    y2: 354.482
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 299.27,
    y1: 354.126,
    x2: 308.535,
    y2: 344.86
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 411.913,
    y1: 401.86,
    x2: 421.535,
    y2: 411.482
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 412.27,
    y1: 411.126,
    x2: 421.535,
    y2: 401.86
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 223.913,
    y1: 473.86,
    x2: 233.535,
    y2: 483.482
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 224.27,
    y1: 483.126,
    x2: 233.535,
    y2: 473.86
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 126.913,
    y1: 301.86,
    x2: 136.535,
    y2: 311.482
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 127.27,
    y1: 311.126,
    x2: 136.535,
    y2: 301.86
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 86.913,
    y1: 284.86,
    x2: 96.535,
    y2: 294.482
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 87.27,
    y1: 294.126,
    x2: 96.535,
    y2: 284.86
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 616.913,
    y1: 81.86,
    x2: 626.535,
    y2: 91.482
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 617.269,
    y1: 91.126,
    x2: 626.535,
    y2: 81.86
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 377.913,
    y1: 92.86,
    x2: 387.535,
    y2: 102.482
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 378.269,
    y1: 102.126,
    x2: 387.535,
    y2: 92.86
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 825.913,
    y1: 380.86,
    x2: 835.535,
    y2: 390.482
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 826.269,
    y1: 390.126,
    x2: 835.535,
    y2: 380.86
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 1053.913,
    y1: 299.86,
    x2: 1063.535,
    y2: 309.482
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 1054.269,
    y1: 309.126,
    x2: 1063.535,
    y2: 299.86
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 1098.913,
    y1: 166.86,
    x2: 1108.535,
    y2: 176.482
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 1099.269,
    y1: 176.126,
    x2: 1108.535,
    y2: 166.86
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 1115.913,
    y1: 177.86,
    x2: 1125.535,
    y2: 187.482
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 1116.269,
    y1: 187.126,
    x2: 1125.535,
    y2: 177.86
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 848.913,
    y1: 502.86,
    x2: 858.535,
    y2: 512.482
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 849.269,
    y1: 512.126,
    x2: 858.535,
    y2: 502.86
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M610.184,490.177c-0.129,0.486-0.227,0.976-0.341,1.464C609.956,491.152,610.056,490.662,610.184,490.177z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14593E",
    d: "M632.872,460.334c-4.489,2.63-8.641,6.008-12.245,10.147c-2.915,3.35-5.286,6.984-7.142,10.794 c0,0.001,0.001,0.002,0.002,0.003c0.007-0.015,0.013-0.03,0.02-0.045c8.244,10.773,19.867,22.868,33.073,34.369 c13.209,11.499,26.79,21.348,38.603,28.026h0.001c3.5-2.355,6.757-5.196,9.659-8.531c1.253-1.438,2.396-2.935,3.453-4.47 c0.482-0.7,0.943-1.411,1.386-2.13c0.103-0.168,0.202-0.338,0.304-0.507c0.174-0.292,0.334-0.588,0.501-0.882 c-13.779,2.083-28.352-1.659-39.688-11.527c-17.975-15.653-21.833-41.479-10.474-61.424c-5.886,0.895-11.623,2.854-16.905,5.856 c0.001,0.001,0.009,0.005,0.009,0.005C633.242,460.119,633.057,460.229,632.872,460.334z M622.378,475.946 c0.652-0.655,1.837-0.655,2.51,0c0.318,0.334,0.514,0.776,0.514,1.256c0,0.459-0.195,0.919-0.514,1.255 c-0.335,0.318-0.797,0.514-1.256,0.514c-0.46,0-0.919-0.195-1.254-0.514c-0.32-0.336-0.514-0.796-0.514-1.255 C621.864,476.723,622.058,476.28,622.378,475.946z M626.111,483.676c0,0.977-1.023,1.768-2,1.768s-2-0.791-2-1.768v-1.77 c0-0.977,1.023-1.769,2-1.769s2,0.792,2,1.769V483.676z M629.111,480.138c0,0.979-0.523,1.769-1.5,1.769s-1.5-0.79-1.5-1.769 v-3.537c0-0.978,0.523-1.769,1.5-1.769s1.5,0.791,1.5,1.769V480.138z M638.111,462.451c0-0.977,1.523-1.769,2.5-1.769 s2.5,0.792,2.5,1.769v5.307c0,0.977-1.523,1.769-2.5,1.769s-2.5-0.792-2.5-1.769V462.451z M638.611,471.295 c0.977,0,1.5,0.791,1.5,1.77v1.768c0,0.977-0.523,1.769-1.5,1.769s-1.5-0.792-1.5-1.769v-1.768 C637.111,472.086,637.635,471.295,638.611,471.295z M634.111,465.988c0-0.977,0.523-1.768,1.5-1.768s1.5,0.791,1.5,1.768v5.307 c0,0.978-0.523,1.77-1.5,1.77s-1.5-0.792-1.5-1.77V465.988z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M699.985,527.991c-0.102,0.169-0.201,0.339-0.304,0.507C699.785,528.33,699.884,528.16,699.985,527.991z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M632.872,460.334c-3.09,1.74-6.108,4.062-8.839,6.574c-14.529-8.037-20.649-8.619-22.036-7.991 c-0.391,1.349,0.556,7.333,9.55,19.693c0.626,0.862,1.271,1.79,1.938,2.665c1.855-3.81,4.227-7.444,7.142-10.794 C624.231,466.342,628.383,462.964,632.872,460.334z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M701.381,525.5c-0.104,0.197-0.209,0.394-0.314,0.59C701.172,525.894,701.277,525.697,701.381,525.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M685.184,543.629c0.964,0.547,1.918,1.077,2.858,1.583c13.479,7.208,19.536,7.317,20.818,6.752 c0.388-1.352-0.559-7.336-9.553-19.696c-0.355-0.488-0.736-0.992-1.108-1.491c0.034-0.049,0.063-0.1,0.097-0.148 c-1.057,1.535-2.2,3.031-3.453,4.47C691.94,538.433,688.684,541.273,685.184,543.629z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M702.59,523.021c-0.08,0.178-0.166,0.353-0.249,0.529C702.424,523.374,702.51,523.199,702.59,523.021z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14593E",
    d: "M639.66,523.557c-9.34-8.133-20.771-19.209-30.161-30.437c-3.341,16.746,2.126,34.762,15.929,46.779 c13.804,12.017,32.405,14.955,48.532,9.338c0-0.001-0.001-0.001-0.001-0.001C661.543,541.48,648.998,531.687,639.66,523.557z  M616.111,510.205c0,0.979-1.023,1.769-2,1.769s-2-0.79-2-1.769v-1.768c0-0.979,1.023-1.77,2-1.77s2,0.791,2,1.77V510.205z  M621.111,515.511c0,0.978-0.523,1.769-1.5,1.769s-1.5-0.791-1.5-1.769v-5.306c0-0.979,0.523-1.768,1.5-1.768s1.5,0.789,1.5,1.768 V515.511z M644.111,545.578c0,0.977-1.023,1.769-2,1.769s-2-0.792-2-1.769v-3.537c0-0.979,1.023-1.769,2-1.769s2,0.79,2,1.769 V545.578z M644.483,540.344c-0.335-0.32-0.512-0.78-0.512-1.256c0-0.462,0.177-0.903,0.512-1.239c0.673-0.653,1.841-0.653,2.513,0 c0.318,0.318,0.514,0.777,0.514,1.239c0,0.476-0.195,0.936-0.531,1.256c-0.318,0.334-0.778,0.529-1.239,0.529 C645.262,540.873,644.821,540.678,644.483,540.344z M649.111,545.578c0,0.977-0.523,1.769-1.5,1.769s-1.5-0.792-1.5-1.769v-1.77 c0-0.977,0.523-1.768,1.5-1.768s1.5,0.791,1.5,1.768V545.578z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D8059",
    d: "M660.798,515.582c11.337,9.868,25.909,13.61,39.688,11.527c0.194-0.34,0.395-0.677,0.58-1.02 c0.105-0.196,0.211-0.393,0.314-0.59c0.336-0.645,0.655-1.295,0.96-1.949c0.083-0.177,0.169-0.352,0.249-0.529 c0.355-0.786,0.69-1.578,1.002-2.377c1.975-5.07,3.062-10.385,3.291-15.719c-11.346-0.903-20.283-10.729-20.283-22.297 c0-5.66,2.141-10.904,5.654-14.891c-0.714-0.701-1.444-1.391-2.209-2.057c-11.345-9.879-25.93-13.618-39.721-11.523 C638.965,474.104,642.823,499.929,660.798,515.582z M699.111,515.511c0-0.978,0.523-1.77,1.5-1.77s1.5,0.792,1.5,1.77v1.769 c0,0.979-0.523,1.77-1.5,1.77s-1.5-0.791-1.5-1.77V515.511z M693.111,510.205c0-0.979,1.523-1.768,2.5-1.768s2.5,0.789,2.5,1.768 v5.306c0,0.978-1.523,1.769-2.5,1.769s-2.5-0.791-2.5-1.769V510.205z M671.111,508.438c0-0.979,0.523-1.77,1.5-1.77 s1.5,0.791,1.5,1.77v5.304c0,0.979-0.523,1.77-1.5,1.77s-1.5-0.791-1.5-1.77V508.438z M671.111,519.049 c0-0.979,0.523-1.77,1.5-1.77s1.5,0.791,1.5,1.77v1.768c0,0.979-0.523,1.769-1.5,1.769s-1.5-0.79-1.5-1.769V519.049z  M666.611,511.974c0.977,0,1.5,0.791,1.5,1.768v1.77c0,0.978-0.523,1.769-1.5,1.769s-1.5-0.791-1.5-1.769v-1.77 C665.111,512.765,665.635,511.974,666.611,511.974z M662.111,458.914c0-0.978,0.523-1.768,1.5-1.768s1.5,0.79,1.5,1.768v7.074 c0,0.979-0.523,1.77-1.5,1.77s-1.5-0.791-1.5-1.77V458.914z M656.611,464.221c0.977,0,1.5,0.791,1.5,1.768v1.77 c0-0.978,1.023-1.77,2-1.77s2,0.792,2,1.77v5.307c0,0.977-1.023,1.768-2,1.768s-2-0.791-2-1.768v-5.307 c0,0.977-0.523,1.769-1.5,1.769s-1.5-0.792-1.5-1.769v-1.77C655.111,465.012,655.635,464.221,656.611,464.221z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2F1D2",
    d: "M703.635,520.543c-0.014,0.034-0.029,0.067-0.043,0.102c-0.311,0.799-0.646,1.591-1.002,2.377 c-0.08,0.178-0.166,0.353-0.249,0.529c-0.305,0.654-0.624,1.305-0.96,1.949c-0.104,0.197-0.209,0.394-0.314,0.59 c-0.183,0.339-0.359,0.68-0.551,1.016c-0.17,0.298-0.354,0.59-0.53,0.886c-0.102,0.169-0.2,0.339-0.304,0.507 c-0.442,0.719-0.903,1.43-1.386,2.13c-0.034,0.049-0.063,0.1-0.097,0.148c0.372,0.499,0.753,1.003,1.108,1.491 c8.994,12.36,9.94,18.345,9.553,19.696c-1.282,0.565-7.339,0.456-20.818-6.752c-0.94-0.506-1.895-1.036-2.858-1.583 c-3.524,2.373-7.301,4.242-11.224,5.608c17.9,11.179,35.522,18.108,42.876,9.67C723.764,550.946,715.904,535.818,703.635,520.543z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2F1D2",
    d: "M699.682,528.498c-0.442,0.719-0.903,1.43-1.386,2.13C698.778,529.928,699.239,529.217,699.682,528.498z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2F1D2",
    d: "M699.985,527.991c0.177-0.296,0.36-0.588,0.53-0.886c-0.01,0.001-0.02,0.002-0.029,0.004 C700.319,527.403,700.159,527.699,699.985,527.991z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2F1D2",
    d: "M609.498,493.118c0.001,0.001,0.001,0.001,0.001,0.002c0.003-0.014,0.006-0.027,0.009-0.041 C609.505,493.092,609.501,493.105,609.498,493.118z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2F1D2",
    d: "M685.183,543.629c-11.813-6.679-25.394-16.527-38.603-28.026c-13.206-11.501-24.829-23.596-33.073-34.369 c-0.007,0.015-0.013,0.03-0.02,0.045c0.001,0.002,0.003,0.005,0.005,0.007c-1.397,2.863-2.5,5.856-3.309,8.892 c-0.128,0.485-0.228,0.976-0.341,1.464c-0.112,0.479-0.237,0.958-0.335,1.438c-0.003,0.014-0.006,0.027-0.009,0.041 c9.391,11.228,20.821,22.304,30.161,30.437c9.338,8.13,21.883,17.924,34.299,25.68c0,0,0.001,0,0.001,0.001 C677.883,547.871,681.659,546.002,685.183,543.629L685.183,543.629z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2F1D2",
    d: "M700.516,527.105c0.191-0.336,0.368-0.677,0.551-1.016c-0.186,0.343-0.386,0.68-0.58,1.02 C700.496,527.107,700.506,527.106,700.516,527.105z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2F1D2",
    d: "M702.341,523.551c-0.305,0.654-0.624,1.305-0.96,1.949C701.717,524.855,702.036,524.205,702.341,523.551z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2F1D2",
    d: "M703.592,520.645c-0.312,0.799-0.646,1.591-1.002,2.377C702.945,522.235,703.281,521.443,703.592,520.645z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2F1D2",
    d: "M609.509,493.07c0.097-0.479,0.223-0.953,0.334-1.43c0.114-0.488,0.212-0.978,0.341-1.464 c0.533-2.017,1.196-4.006,1.991-5.958C611,487.101,610.112,490.063,609.509,493.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2F1D2",
    d: "M612.251,484.034c0.382-0.928,0.793-1.847,1.236-2.756c-0.001-0.001-0.002-0.002-0.002-0.003 C613.043,482.186,612.634,483.105,612.251,484.034z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2F1D2",
    d: "M633.428,460.02c0,0-0.008-0.004-0.009-0.005c-0.184,0.104-0.365,0.213-0.547,0.319 C633.057,460.229,633.242,460.119,633.428,460.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2F1D2",
    d: "M609.509,493.07c0.604-3.007,1.491-5.97,2.666-8.852c0.025-0.063,0.051-0.123,0.076-0.185 c0.383-0.929,0.792-1.849,1.234-2.759c-0.667-0.875-1.313-1.803-1.938-2.665c-8.994-12.36-9.94-18.345-9.55-19.693 c1.387-0.628,7.507-0.046,22.036,7.991c2.73-2.513,5.749-4.834,8.839-6.574c0.182-0.106,0.363-0.215,0.547-0.319 c-0.048-0.026-1.31-0.723-2.079-1.162c-19.061-10.898-31.597-13.282-37.373-6.65c-7.352,8.445,1.971,24.835,15.506,41.026 c0.008-0.037,0.019-0.073,0.025-0.11l0,0C609.501,493.103,609.506,493.086,609.509,493.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2F1D2",
    d: "M609.509,493.07c-0.003,0.016-0.008,0.032-0.011,0.048l0,0c0.003-0.013,0.007-0.026,0.01-0.039 C609.508,493.076,609.509,493.073,609.509,493.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2F1D2",
    d: "M609.508,493.079c0.098-0.48,0.223-0.959,0.335-1.438c-0.111,0.477-0.237,0.951-0.334,1.43 C609.509,493.073,609.508,493.076,609.508,493.079z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2F1D2",
    d: "M612.175,484.219c0.025-0.062,0.051-0.123,0.076-0.185C612.226,484.096,612.2,484.156,612.175,484.219z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2F1D2",
    d: "M612.175,484.219c-0.795,1.952-1.458,3.941-1.991,5.958c0.809-3.035,1.911-6.028,3.309-8.892 c-0.002-0.002-0.004-0.005-0.005-0.007c-0.443,0.909-0.854,1.828-1.236,2.756C612.226,484.096,612.2,484.157,612.175,484.219z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D8059",
    d: "M640.611,469.526c0.977,0,2.5-0.792,2.5-1.769v-5.307c0-0.977-1.523-1.769-2.5-1.769s-2.5,0.792-2.5,1.769 v5.307C638.111,468.734,639.635,469.526,640.611,469.526z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D8059",
    d: "M635.611,473.064c0.977,0,1.5-0.792,1.5-1.77v-5.307c0-0.977-0.523-1.768-1.5-1.768s-1.5,0.791-1.5,1.768 v5.307C634.111,472.272,634.635,473.064,635.611,473.064z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D8059",
    d: "M637.111,474.832c0,0.977,0.523,1.769,1.5,1.769s1.5-0.792,1.5-1.769v-1.768c0-0.979-0.523-1.77-1.5-1.77 s-1.5,0.791-1.5,1.77V474.832z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D8059",
    d: "M624.111,480.138c-0.977,0-2,0.792-2,1.769v1.77c0,0.977,1.023,1.768,2,1.768s2-0.791,2-1.768v-1.77 C626.111,480.93,625.088,480.138,624.111,480.138z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D8059",
    d: "M623.632,478.971c0.459,0,0.921-0.195,1.256-0.514c0.318-0.336,0.514-0.796,0.514-1.255 c0-0.479-0.195-0.922-0.514-1.256c-0.673-0.655-1.857-0.655-2.51,0c-0.32,0.334-0.514,0.776-0.514,1.256 c0,0.459,0.193,0.919,0.514,1.255C622.713,478.775,623.172,478.971,623.632,478.971z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D8059",
    d: "M627.611,474.832c-0.977,0-1.5,0.791-1.5,1.769v3.537c0,0.979,0.523,1.769,1.5,1.769s1.5-0.79,1.5-1.769 v-3.537C629.111,475.623,628.588,474.832,627.611,474.832z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D8059",
    d: "M614.111,506.668c-0.977,0-2,0.791-2,1.77v1.768c0,0.979,1.023,1.769,2,1.769s2-0.79,2-1.769v-1.768 C616.111,507.459,615.088,506.668,614.111,506.668z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D8059",
    d: "M619.611,508.438c-0.977,0-1.5,0.789-1.5,1.768v5.306c0,0.978,0.523,1.769,1.5,1.769s1.5-0.791,1.5-1.769 v-5.306C621.111,509.227,620.588,508.438,619.611,508.438z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M665.111,515.511c0,0.978,0.523,1.769,1.5,1.769s1.5-0.791,1.5-1.769v-1.77c0-0.977-0.523-1.768-1.5-1.768 s-1.5,0.791-1.5,1.768V515.511z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M672.611,522.585c0.977,0,1.5-0.79,1.5-1.769v-1.768c0-0.979-0.523-1.77-1.5-1.77s-1.5,0.791-1.5,1.77 v1.768C671.111,521.795,671.635,522.585,672.611,522.585z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M672.611,515.511c0.977,0,1.5-0.791,1.5-1.77v-5.304c0-0.979-0.523-1.77-1.5-1.77s-1.5,0.791-1.5,1.77 v5.304C671.111,514.72,671.635,515.511,672.611,515.511z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D8059",
    d: "M642.111,540.272c-0.977,0-2,0.79-2,1.769v3.537c0,0.977,1.023,1.769,2,1.769s2-0.792,2-1.769v-3.537 C644.111,541.063,643.088,540.272,642.111,540.272z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D8059",
    d: "M647.611,542.041c-0.977,0-1.5,0.791-1.5,1.768v1.77c0,0.977,0.523,1.769,1.5,1.769s1.5-0.792,1.5-1.769 v-1.77C649.111,542.832,648.588,542.041,647.611,542.041z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D8059",
    d: "M647.51,539.088c0-0.462-0.195-0.921-0.514-1.239c-0.672-0.653-1.84-0.653-2.513,0 c-0.335,0.336-0.512,0.777-0.512,1.239c0,0.476,0.177,0.936,0.512,1.256c0.338,0.334,0.778,0.529,1.256,0.529 c0.461,0,0.921-0.195,1.239-0.529C647.314,540.023,647.51,539.563,647.51,539.088z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M663.611,467.758c0.977,0,1.5-0.791,1.5-1.77v-7.074c0-0.978-0.523-1.768-1.5-1.768s-1.5,0.79-1.5,1.768 v7.074C662.111,466.967,662.635,467.758,663.611,467.758z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M656.611,469.526c0.977,0,1.5-0.792,1.5-1.769v-1.77c0-0.977-0.523-1.768-1.5-1.768s-1.5,0.791-1.5,1.768 v1.77C655.111,468.734,655.635,469.526,656.611,469.526z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M660.111,474.832c0.977,0,2-0.791,2-1.768v-5.307c0-0.978-1.023-1.77-2-1.77s-2,0.792-2,1.77v5.307 C658.111,474.041,659.135,474.832,660.111,474.832z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M700.611,519.049c0.977,0,1.5-0.791,1.5-1.77v-1.769c0-0.978-0.523-1.77-1.5-1.77s-1.5,0.792-1.5,1.77 v1.769C699.111,518.258,699.635,519.049,700.611,519.049z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M695.611,517.279c0.977,0,2.5-0.791,2.5-1.769v-5.306c0-0.979-1.523-1.768-2.5-1.768s-2.5,0.789-2.5,1.768 v5.306C693.111,516.488,694.635,517.279,695.611,517.279z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 938.062,
    y1: 337.127,
    x2: 912.523,
    y2: 362.665
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 937.116,
    y1: 361.719,
    x2: 912.523,
    y2: 337.127
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 1062.062,
    y1: 479.127,
    x2: 1036.523,
    y2: 504.665
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 1061.116,
    y1: 503.719,
    x2: 1036.523,
    y2: 479.127
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 422.063,
    y1: 432.127,
    x2: 396.523,
    y2: 457.665
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 421.117,
    y1: 456.719,
    x2: 396.523,
    y2: 432.127
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 144.063,
    y1: 104.127,
    x2: 118.523,
    y2: 129.665
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 143.117,
    y1: 128.719,
    x2: 118.523,
    y2: 104.127
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 941.386,
    y1: 243.906,
    x2: 923.796,
    y2: 261.496
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 940.733,
    y1: 260.845,
    x2: 923.796,
    y2: 243.906
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 1035.386,
    y1: 133.906,
    x2: 1017.796,
    y2: 151.496
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 1034.733,
    y1: 150.845,
    x2: 1017.796,
    y2: 133.906
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 974.386,
    y1: 79.906,
    x2: 956.796,
    y2: 97.496
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 973.733,
    y1: 96.845,
    x2: 956.796,
    y2: 79.906
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 672.774,
    y1: 357.4,
    x2: 632.563,
    y2: 397.611
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D6E9FF",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 671.286,
    y1: 396.125,
    x2: 632.563,
    y2: 357.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A2F1D2",
    d: "M506.111,65.7c0,0.637-0.861,1.155-1.5,1.155c-0.638,0-1.5-0.519-1.5-1.155V65h-30.66 c5.15,9.106,13.598,16.383,24.34,19.852c19.888,6.423,41.035-2.332,50.92-19.852h-41.6V65.7z M502.111,81.091 c0,0.638-0.862,1.154-1.5,1.154s-1.5-0.517-1.5-1.154v-1.539c0-0.637,0.862-1.155,1.5-1.155s1.5,0.519,1.5,1.155V81.091z  M505.111,80.322c0,0.637-0.361,1.153-1,1.153c-0.638,0-1-0.517-1-1.153v-3.079c0-0.638,0.362-1.153,1-1.153 c0.639,0,1,0.516,1,1.153V80.322z M530.111,74.165c0-0.637,0.362-1.153,1-1.153s1,0.517,1,1.153v1.54c0,0.636-0.362,1.154-1,1.154 s-1-0.519-1-1.154V74.165z M527.111,76.474c0-0.638,0.862-1.154,1.5-1.154c0.637,0,1.5,0.517,1.5,1.154v1.54 c0,0.637-0.863,1.154-1.5,1.154c-0.638,0-1.5-0.518-1.5-1.154V76.474z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M504.611,66.855c0.639,0,1.5-0.519,1.5-1.155V65h-3v0.7C503.111,66.337,503.974,66.855,504.611,66.855z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M500.611,78.396c-0.638,0-1.5,0.519-1.5,1.155v1.539c0,0.638,0.862,1.154,1.5,1.154s1.5-0.517,1.5-1.154 v-1.539C502.111,78.915,501.249,78.396,500.611,78.396z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M504.111,76.09c-0.638,0-1,0.516-1,1.153v3.079c0,0.637,0.362,1.153,1,1.153c0.639,0,1-0.517,1-1.153 v-3.079C505.111,76.605,504.75,76.09,504.111,76.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M531.111,76.859c0.638,0,1-0.519,1-1.154v-1.54c0-0.637-0.362-1.153-1-1.153s-1,0.517-1,1.153v1.54 C530.111,76.341,530.474,76.859,531.111,76.859z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M528.611,79.168c0.637,0,1.5-0.518,1.5-1.154v-1.54c0-0.638-0.863-1.154-1.5-1.154 c-0.638,0-1.5,0.517-1.5,1.154v1.54C527.111,78.65,527.974,79.168,528.611,79.168z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M614.959,258.27c0.846,5.4,2.048,9.459,3.647,13.91C617.093,267.641,615.871,262.995,614.959,258.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M806.699,167.384c-0.336-0.403-0.673-0.805-1.014-1.202C806.027,166.579,806.363,166.981,806.699,167.384z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M804.909,165.29c-0.397-0.453-0.794-0.907-1.197-1.353C804.116,164.384,804.512,164.838,804.909,165.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M866.576,172.677c-2.458-1.923-15.613-4.929-48.613,3.419c-1.313,0.335-2.662,0.694-4.006,1.055 c7.525,11.391,12.906,24.135,15.787,37.557c1.928-1.539,3.816-3.074,5.631-4.6C861.439,188.227,866.696,175.796,866.576,172.677z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M803.431,163.634c-1.007-1.103-2.034-2.182-3.08-3.236C801.4,161.457,802.428,162.535,803.431,163.634z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M798.651,158.723c0.446,0.432,0.894,0.862,1.332,1.301C799.544,159.584,799.098,159.153,798.651,158.723z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M585.705,316.435c2.458,1.921,15.607,4.925,48.609-3.421c2.301-0.579,4.672-1.174,7.048-1.837 c-9.136-10.103-16.29-21.814-21.133-34.466C591.615,300.052,585.548,313.053,585.705,316.435z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M778.622,304.814c-9.87-3.187-18.977-7.642-27.199-13.126c-0.302,0.155-0.613,0.319-0.913,0.473 c-24.551,12.565-56.92,27.007-87.91,37.107c-7.746-5.055-14.9-11.119-21.248-18.135c26.941-7.498,58.605-20.053,90.692-35.962 c-26.112-28.129-36.655-69.168-24.022-108.291c4.747-14.702,12.313-27.706,21.898-38.618 c-49.002-3.328-95.837,26.821-111.609,75.673c-5.184,16.052-6.462,32.426-4.369,48.101c0.083-0.01,0.164-0.036,0.247-0.036 c0.003,0,0.005,0,0.008,0c0.21,2.312,0.466,4.369,0.763,6.27c0.912,4.726,2.134,9.371,3.647,13.91 c0.516,1.436,1.072,2.912,1.672,4.491c-0.017,0.014-0.032,0.026-0.049,0.04c4.843,12.651,11.997,24.363,21.133,34.466 c0.003-0.001,0.006-0.001,0.009-0.002c6.35,7.019,13.525,13.114,21.268,18.17h-0.001c7.979,5.206,16.771,9.456,26.273,12.524 c42.886,13.85,88.075-0.149,116.036-31.98C796.186,309.294,787.356,307.635,778.622,304.814z M683.611,265.057 c1.615,0,2.5,1.31,2.5,2.924v3.901c0,1.615-0.885,2.925-2.5,2.925c-1.616,0-2.5-1.31-2.5-2.925v-3.901 C681.111,266.366,681.995,265.057,683.611,265.057z M676.111,160.717c0-1.614,0.883-2.924,2.5-2.924s2.5,1.31,2.5,2.924v7.802 c0,1.615-0.883,2.925-2.5,2.925s-2.5-1.31-2.5-2.925V160.717z M675.111,260.179c0-1.612,0.885-2.923,2.5-2.923 c1.617,0,2.5,1.311,2.5,2.923v5.852c0,1.614-0.883,2.926-2.5,2.926c-1.615,0-2.5-1.312-2.5-2.926V260.179z M665.111,168.519 c0-1.615,0.883-2.925,2.5-2.925c1.616,0,2.5,1.31,2.5,2.925v1.949c0,1.615-0.884,2.927-2.5,2.927c-1.617,0-2.5-1.312-2.5-2.927 V168.519z M664.111,184.12c0-1.616,0.883-2.927,2.5-2.927c1.616,0,2.5,1.311,2.5,2.927v3.901c0,1.615-0.884,2.924-2.5,2.924 c-1.617,0-2.5-1.309-2.5-2.924V184.12z M654.111,176.32c0-1.616,0.883-2.926,2.5-2.926c1.619,0,2.5,1.31,2.5,2.926v3.9 c0,1.613-0.881,2.925-2.5,2.925c-1.617,0-2.5-1.312-2.5-2.925V176.32z M652.111,191.92c0-1.614,1.384-2.923,3-2.923 c1.617,0,3,1.309,3,2.923v7.803c0,1.616-1.383,2.925-3,2.925c-1.616,0-3-1.309-3-2.925V191.92z M652.111,223.125v3.9 c0,1.615-1.884,2.926-3.5,2.926s-3.5-1.311-3.5-2.926v-3.9c0-1.615,1.884-2.924,3.5-2.924S652.111,221.51,652.111,223.125z  M643.111,186.07c0-1.614,1.886-2.925,3.5-2.925c1.616,0,3.5,1.311,3.5,2.925v1.951c0,1.615-1.884,2.924-3.5,2.924 c-1.614,0-3.5-1.309-3.5-2.924V186.07z M636.111,223.125v-3.9c0-1.614,1.885-2.927,3.5-2.927c1.619,0,3.5,1.313,3.5,2.927v3.9 c0,1.615-1.881,2.926-3.5,2.926C637.996,226.051,636.111,224.74,636.111,223.125z M638.111,236.776v-3.899 c0-1.616,1.883-2.926,3.5-2.926s3.5,1.31,3.5,2.926v3.899c0,1.616-1.883,2.927-3.5,2.927S638.111,238.393,638.111,236.776z  M706.111,332.338c0,1.615-1.384,2.928-3,2.928c-1.618,0-3-1.313-3-2.928v-3.899c0-1.614,1.382-2.924,3-2.924 c1.616,0,3,1.31,3,2.924V332.338z M714.111,330.389c0,1.615-1.382,2.927-3,2.927s-3-1.312-3-2.927v-7.8 c0-1.615,1.382-2.927,3-2.927s3,1.312,3,2.927V330.389z M776.111,324.539c0,1.614-1.882,2.925-3.5,2.925 c-1.617,0-3.5-1.311-3.5-2.925v-3.901c0-1.615,1.883-2.925,3.5-2.925c1.618,0,3.5,1.31,3.5,2.925V324.539z M781.111,318.688 c0,1.614-0.883,2.926-2.5,2.926c-1.619,0-2.5-1.312-2.5-2.926v-3.9c0-1.614,0.881-2.925,2.5-2.925c1.617,0,2.5,1.311,2.5,2.925 V318.688z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M808.489,169.588c-0.268-0.339-0.539-0.674-0.811-1.01C807.95,168.914,808.222,169.25,808.489,169.588z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M810.244,171.865c-0.107-0.144-0.219-0.284-0.326-0.427C810.025,171.581,810.137,171.722,810.244,171.865z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5CE7B0",
    d: "M751.423,291.688c8.223,5.484,17.329,9.939,27.199,13.126c8.734,2.82,17.563,4.479,26.325,5.074 c9.585-10.912,17.15-23.915,21.897-38.617c3.08-9.538,4.774-19.19,5.21-28.743c-0.012,0.009-0.022,0.017-0.034,0.025 C806.024,261.551,775.818,279.15,751.423,291.688z M799.111,287.483c0,1.614-1.384,2.926-3,2.926s-3-1.312-3-2.926v-5.849 c0-1.616,1.384-2.928,3-2.928s3,1.312,3,2.928V287.483z M807.111,293.336c0,1.613-1.383,2.923-3,2.923s-3-1.31-3-2.923v-5.853 c0-1.615,1.383-2.926,3-2.926s3,1.311,3,2.926V293.336z M807.111,279.682c0,1.617-1.383,2.926-3,2.926s-3-1.309-3-2.926v-7.8 c0-1.615,1.383-2.926,3-2.926s3,1.311,3,2.926V279.682z M816.111,287.483c0,1.614-0.884,2.926-2.5,2.926 c-1.617,0-2.5-1.312-2.5-2.926v-5.849c0-1.616,0.883-2.928,2.5-2.928c1.616,0,2.5,1.312,2.5,2.928V287.483z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5CE7B0",
    d: "M732.044,275.172c2.588-1.282,5.178-2.58,7.769-3.906c34.715-17.777,66.324-37.676,89.922-56.551 c0.003-0.003,0.006-0.005,0.01-0.008c-2.881-13.422-8.262-26.166-15.787-37.557l0,0c-1.191-1.807-2.431-3.568-3.713-5.285 c-0.107-0.144-0.219-0.284-0.326-0.427c-0.471-0.623-0.946-1.239-1.429-1.851c-0.268-0.338-0.539-0.674-0.811-1.01 c-0.324-0.401-0.65-0.799-0.979-1.194c-0.336-0.402-0.672-0.805-1.014-1.202c-0.257-0.3-0.518-0.596-0.776-0.892 c-0.397-0.452-0.793-0.906-1.197-1.353c-0.093-0.103-0.188-0.201-0.281-0.304c-1.003-1.099-2.03-2.177-3.08-3.236 c-0.123-0.124-0.243-0.251-0.367-0.374c-0.438-0.438-0.886-0.869-1.332-1.301c-0.267-0.257-0.532-0.516-0.801-0.77 c-11.496-10.879-25.538-19.43-41.605-24.616c-8.734-2.82-17.564-4.479-26.325-5.074c-9.586,10.912-17.151,23.916-21.898,38.618 C695.389,206.004,705.932,247.043,732.044,275.172z M797.111,189.971c0-1.614,0.384-2.926,2-2.926c1.618,0,2,1.312,2,2.926v3.902 c0,1.614-0.382,2.925-2,2.925c-1.616,0-2-1.311-2-2.925V189.971z M793.111,205.573c0-1.614,1.384-2.926,3-2.926s3,1.312,3,2.926 v3.899c0,1.616-1.384,2.926-3,2.926s-3-1.31-3-2.926V205.573z M786.111,195.821c0-1.614,0.883-2.924,2.5-2.924s2.5,1.31,2.5,2.924 v7.801c0,1.616-0.883,2.927-2.5,2.927s-2.5-1.311-2.5-2.927V195.821z M746.111,141.216c0-1.615,0.884-2.927,2.5-2.927 c1.617,0,2.5,1.312,2.5,2.927v5.85c0,1.615-0.883,2.924-2.5,2.924c-1.616,0-2.5-1.309-2.5-2.924V141.216z M736.111,150.964 c0-1.612,1.383-2.923,3-2.923c1.615,0,3,1.311,3,2.923v1.953c0,1.614-1.385,2.925-3,2.925c-1.617,0-3-1.311-3-2.925V150.964z  M731.111,244.578c0-1.616,1.383-2.925,3-2.925c1.615,0,3,1.309,3,2.925v3.901c0,1.614-1.385,2.923-3,2.923 c-1.617,0-3-1.309-3-2.923V244.578z M726.111,252.378c0-1.613,0.884-2.923,2.5-2.923c1.617,0,2.5,1.31,2.5,2.923v3.901 c0,1.615-0.883,2.926-2.5,2.926c-1.616,0-2.5-1.311-2.5-2.926V252.378z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14593E",
    d: "M732.044,275.172c-32.087,15.909-63.751,28.464-90.692,35.962c6.348,7.016,13.502,13.08,21.248,18.135 c30.99-10.101,63.359-24.542,87.91-37.107c0.3-0.153,0.611-0.317,0.913-0.473C744.264,286.913,737.78,281.353,732.044,275.172z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14593E",
    d: "M799.983,160.023c0.124,0.123,0.244,0.25,0.367,0.374c1.046,1.055,2.073,2.134,3.08,3.236 c0.093,0.102,0.188,0.202,0.281,0.304c0.403,0.445,0.8,0.899,1.197,1.353c0.26,0.296,0.52,0.593,0.776,0.892 c0.341,0.397,0.678,0.799,1.014,1.202c0.33,0.396,0.655,0.794,0.979,1.194c0.271,0.336,0.543,0.671,0.811,1.01 c0.483,0.611,0.959,1.229,1.429,1.851c0.107,0.143,0.219,0.283,0.326,0.427c1.291,1.726,2.526,3.49,3.713,5.285 c1.344-0.36,2.693-0.72,4.006-1.055c33-8.348,46.155-5.342,48.613-3.419c0.12,3.119-5.137,15.55-31.201,37.431 c-1.814,1.525-3.703,3.061-5.631,4.6c1.939,9.037,2.741,18.38,2.311,27.821c7.355-5.377,14.37-10.865,20.82-16.381 c-0.823-2.329-1.275-4.827-1.275-7.419c0-12.142,9.843-22.273,21.984-22.273l7.356,0.014c8.585-12.548,11.771-24.415,6.599-34.521 c-10.709-20.921-48.489-17.204-90.224-4.508c0.181,0.168,0.355,0.344,0.535,0.514c0.269,0.255,0.535,0.512,0.801,0.77 C799.098,159.153,799.544,159.584,799.983,160.023z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14593E",
    d: "M813.957,177.15L813.957,177.15c-1.187-1.795-2.422-3.56-3.713-5.285 C811.526,173.582,812.766,175.344,813.957,177.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14593E",
    d: "M807.679,168.578c-0.324-0.4-0.649-0.799-0.979-1.194C807.028,167.779,807.354,168.177,807.679,168.578z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14593E",
    d: "M799.983,160.023c0.124,0.123,0.244,0.25,0.367,0.374C800.228,160.273,800.107,160.146,799.983,160.023z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14593E",
    d: "M803.712,163.938c-0.093-0.102-0.188-0.202-0.281-0.304C803.523,163.736,803.619,163.835,803.712,163.938z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14593E",
    d: "M805.686,166.182c-0.257-0.299-0.517-0.596-0.776-0.892C805.168,165.586,805.429,165.882,805.686,166.182z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14593E",
    d: "M797.851,157.953c0.269,0.254,0.534,0.513,0.801,0.77C798.386,158.465,798.119,158.208,797.851,157.953z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14593E",
    d: "M809.918,171.438c-0.47-0.621-0.945-1.239-1.429-1.851C808.972,170.199,809.447,170.815,809.918,171.438z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14593E",
    d: "M829.744,214.707c-0.004,0.003-0.007,0.005-0.01,0.008c-23.598,18.875-55.207,38.773-89.922,56.551 c-2.591,1.326-5.181,2.624-7.769,3.906c5.736,6.181,12.22,11.741,19.379,16.517c24.396-12.538,54.602-30.138,80.598-49.135 c0.012-0.009,0.022-0.017,0.034-0.025C832.485,233.087,831.684,223.744,829.744,214.707z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14593E",
    d: "M620.278,276.671c-0.6-1.579-1.156-3.056-1.672-4.491c0.508,1.523,1.049,3.034,1.623,4.531 C620.246,276.697,620.262,276.685,620.278,276.671z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14593E",
    d: "M614.196,252c-0.003,0-0.005,0-0.008,0c-0.083,0-0.164,0.026-0.247,0.036 c0.279,2.091,0.62,4.17,1.018,6.233C614.662,256.369,614.406,254.312,614.196,252z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14593E",
    d: "M641.371,311.175c-0.003,0.001-0.006,0.001-0.009,0.002c6.213,6.87,13.343,12.992,21.275,18.168h0.001 C654.896,324.289,647.721,318.193,641.371,311.175z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14593E",
    d: "M641.362,311.177c-2.376,0.663-4.747,1.258-7.048,1.837c-33.002,8.346-46.151,5.342-48.609,3.421 c-0.157-3.382,5.91-16.383,34.524-39.724c-0.574-1.497-1.115-3.008-1.623-4.531c-1.6-4.451-2.802-8.51-3.647-13.91 c-0.397-2.063-0.738-4.143-1.018-6.233c-1.699,0.187-3.232,2.213-4.736,3.402c-38.315,30.368-53.301,54.444-44.377,71.882 c11.359,22.189,53.127,16.586,97.81,2.024C654.705,324.169,647.575,318.047,641.362,311.177z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409670",
    d: "M678.611,171.443c1.617,0,2.5-1.31,2.5-2.925v-7.802c0-1.614-0.883-2.924-2.5-2.924s-2.5,1.31-2.5,2.924 v7.802C676.111,170.134,676.994,171.443,678.611,171.443z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409670",
    d: "M667.611,173.395c1.616,0,2.5-1.312,2.5-2.927v-1.949c0-1.615-0.884-2.925-2.5-2.925 c-1.617,0-2.5,1.31-2.5,2.925v1.949C665.111,172.083,665.994,173.395,667.611,173.395z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409670",
    d: "M656.611,183.146c1.619,0,2.5-1.312,2.5-2.925v-3.9c0-1.616-0.881-2.926-2.5-2.926 c-1.617,0-2.5,1.31-2.5,2.926v3.9C654.111,181.834,654.994,183.146,656.611,183.146z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409670",
    d: "M646.611,190.945c1.616,0,3.5-1.309,3.5-2.924v-1.951c0-1.614-1.884-2.925-3.5-2.925 c-1.614,0-3.5,1.311-3.5,2.925v1.951C643.111,189.637,644.997,190.945,646.611,190.945z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409670",
    d: "M655.111,202.647c1.617,0,3-1.309,3-2.925v-7.803c0-1.614-1.383-2.923-3-2.923c-1.616,0-3,1.309-3,2.923 v7.803C652.111,201.339,653.495,202.647,655.111,202.647z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409670",
    d: "M666.611,190.945c1.616,0,2.5-1.309,2.5-2.924v-3.901c0-1.616-0.884-2.927-2.5-2.927 c-1.617,0-2.5,1.311-2.5,2.927v3.901C664.111,189.637,664.994,190.945,666.611,190.945z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409670",
    d: "M643.111,223.125v-3.9c0-1.614-1.881-2.927-3.5-2.927c-1.615,0-3.5,1.313-3.5,2.927v3.9 c0,1.615,1.885,2.926,3.5,2.926C641.23,226.051,643.111,224.74,643.111,223.125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409670",
    d: "M645.111,236.776v-3.899c0-1.616-1.883-2.926-3.5-2.926s-3.5,1.31-3.5,2.926v3.899 c0,1.616,1.883,2.927,3.5,2.927S645.111,238.393,645.111,236.776z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409670",
    d: "M645.111,223.125v3.9c0,1.615,1.884,2.926,3.5,2.926s3.5-1.311,3.5-2.926v-3.9 c0-1.615-1.884-2.924-3.5-2.924S645.111,221.51,645.111,223.125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409670",
    d: "M677.611,268.956c1.617,0,2.5-1.312,2.5-2.926v-5.852c0-1.612-0.883-2.923-2.5-2.923 c-1.615,0-2.5,1.311-2.5,2.923v5.852C675.111,267.645,675.996,268.956,677.611,268.956z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409670",
    d: "M681.111,271.882c0,1.615,0.884,2.925,2.5,2.925c1.615,0,2.5-1.31,2.5-2.925v-3.901 c0-1.614-0.885-2.924-2.5-2.924c-1.616,0-2.5,1.31-2.5,2.924V271.882z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409670",
    d: "M703.111,325.515c-1.618,0-3,1.31-3,2.924v3.899c0,1.615,1.382,2.928,3,2.928c1.616,0,3-1.313,3-2.928 v-3.899C706.111,326.824,704.728,325.515,703.111,325.515z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409670",
    d: "M711.111,319.662c-1.618,0-3,1.312-3,2.927v7.8c0,1.615,1.382,2.927,3,2.927s3-1.312,3-2.927v-7.8 C714.111,320.974,712.729,319.662,711.111,319.662z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409670",
    d: "M778.611,311.862c-1.619,0-2.5,1.311-2.5,2.925v3.9c0,1.614,0.881,2.926,2.5,2.926 c1.617,0,2.5-1.312,2.5-2.926v-3.9C781.111,313.173,780.229,311.862,778.611,311.862z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409670",
    d: "M772.611,317.713c-1.617,0-3.5,1.31-3.5,2.925v3.901c0,1.614,1.883,2.925,3.5,2.925 c1.618,0,3.5-1.311,3.5-2.925v-3.901C776.111,319.022,774.229,317.713,772.611,317.713z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M748.611,149.989c1.617,0,2.5-1.309,2.5-2.924v-5.85c0-1.615-0.883-2.927-2.5-2.927 c-1.616,0-2.5,1.312-2.5,2.927v5.85C746.111,148.681,746.995,149.989,748.611,149.989z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M739.111,155.842c1.615,0,3-1.311,3-2.925v-1.953c0-1.612-1.385-2.923-3-2.923c-1.617,0-3,1.311-3,2.923 v1.953C736.111,154.531,737.494,155.842,739.111,155.842z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M799.111,196.798c1.618,0,2-1.311,2-2.925v-3.902c0-1.614-0.382-2.926-2-2.926c-1.616,0-2,1.312-2,2.926 v3.902C797.111,195.487,797.495,196.798,799.111,196.798z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M788.611,206.549c1.617,0,2.5-1.311,2.5-2.927v-7.801c0-1.614-0.883-2.924-2.5-2.924s-2.5,1.31-2.5,2.924 v7.801C786.111,205.238,786.994,206.549,788.611,206.549z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M796.111,212.398c1.616,0,3-1.31,3-2.926v-3.899c0-1.614-1.384-2.926-3-2.926s-3,1.312-3,2.926v3.899 C793.111,211.089,794.495,212.398,796.111,212.398z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M728.611,259.205c1.617,0,2.5-1.311,2.5-2.926v-3.901c0-1.613-0.883-2.923-2.5-2.923 c-1.616,0-2.5,1.31-2.5,2.923v3.901C726.111,257.895,726.995,259.205,728.611,259.205z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M734.111,251.402c1.615,0,3-1.309,3-2.923v-3.901c0-1.616-1.385-2.925-3-2.925c-1.617,0-3,1.309-3,2.925 v3.901C731.111,250.094,732.494,251.402,734.111,251.402z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M813.611,278.707c-1.617,0-2.5,1.312-2.5,2.928v5.849c0,1.614,0.883,2.926,2.5,2.926 c1.616,0,2.5-1.312,2.5-2.926v-5.849C816.111,280.019,815.228,278.707,813.611,278.707z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M804.111,268.956c-1.617,0-3,1.311-3,2.926v7.8c0,1.617,1.383,2.926,3,2.926s3-1.309,3-2.926v-7.8 C807.111,270.267,805.729,268.956,804.111,268.956z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M804.111,284.558c-1.617,0-3,1.311-3,2.926v5.853c0,1.613,1.383,2.923,3,2.923s3-1.31,3-2.923v-5.853 C807.111,285.868,805.729,284.558,804.111,284.558z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M796.111,278.707c-1.616,0-3,1.312-3,2.928v5.849c0,1.614,1.384,2.926,3,2.926s3-1.312,3-2.926v-5.849 C799.111,280.019,797.728,278.707,796.111,278.707z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M402.969,324.555c-35.74-11.539-56.711-47.585-50.365-83.555h-19.492v1.678c0,1.095-1.404,1.984-2.5,1.984 s-2.5-0.89-2.5-1.984V241h-12.19c-3.518,5.4-6.398,11.339-8.474,17.767c-12.617,39.067,8.826,80.958,47.894,93.572 c30.54,9.862,62.805-1.09,81.46-25.004C425.805,328.988,414.271,328.205,402.969,324.555z M322.111,246.647 c0-1.098,0.903-1.985,2-1.985s2,0.888,2,1.985v1.322c0,1.095-0.903,1.983-2,1.983s-2-0.889-2-1.983V246.647z M318.111,271.784 v-2.646c0-1.097,0.903-1.986,2-1.986c1.096,0,2,0.89,2,1.986v2.646c0,1.095-0.904,1.984-2,1.984 C319.015,273.769,318.111,272.879,318.111,271.784z M323.111,281.046c0,1.094-0.403,1.983-1.5,1.983c-1.096,0-1.5-0.89-1.5-1.983 V278.4c0-1.097,0.404-1.986,1.5-1.986c1.097,0,1.5,0.89,1.5,1.986V281.046z M327.111,274.432c0,1.094-0.904,1.982-2,1.982 c-1.097,0-2-0.889-2-1.982v-2.647c0-1.096,0.903-1.985,2-1.985c1.096,0,2,0.89,2,1.985V274.432z M332.111,255.908 c0,1.096-1.403,1.984-2.5,1.984c-1.096,0-2.5-0.889-2.5-1.984v-5.293c0-1.096,1.404-1.983,2.5-1.983c1.097,0,2.5,0.888,2.5,1.983 V255.908z M338.111,247.97c0,1.095-0.404,1.983-1.5,1.983s-1.5-0.889-1.5-1.983v-2.646c0-1.095,0.404-1.984,1.5-1.984 s1.5,0.89,1.5,1.984V247.97z M365.111,345.873c0,1.096-1.404,1.984-2.5,1.984s-2.5-0.889-2.5-1.984v-2.646 c0-1.095,1.404-1.985,2.5-1.985s2.5,0.891,2.5,1.985V345.873z M363.611,317.429c-1.096,0-2.5-0.89-2.5-1.986v-3.968 c0-1.095,1.404-1.984,2.5-1.984s2.5,0.89,2.5,1.984v3.968C366.111,316.539,364.707,317.429,363.611,317.429z M369.111,344.551 c0,1.095-0.403,1.984-1.5,1.984s-1.5-0.89-1.5-1.984v-5.293c0-1.096,0.403-1.983,1.5-1.983s1.5,0.888,1.5,1.983V344.551z  M371.111,319.412c0,1.096-0.903,1.985-2,1.985s-2-0.89-2-1.985v-2.646c0-1.097,0.903-1.983,2-1.983s2,0.887,2,1.983V319.412z  M412.111,340.582c0,1.095-0.904,1.984-2,1.984c-1.097,0-2-0.89-2-1.984v-2.647c0-1.096,0.903-1.985,2-1.985 c1.096,0,2,0.89,2,1.985V340.582z M417.111,336.612c0,1.095-1.404,1.984-2.5,1.984s-2.5-0.89-2.5-1.984v-2.647 c0-1.095,1.404-1.982,2.5-1.982s2.5,0.888,2.5,1.982V336.612z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2F1D2",
    d: "M373.584,241h-20.98c-6.346,35.97,14.625,72.016,50.365,83.555c11.302,3.65,22.836,4.434,33.832,2.78 c5.209-6.677,9.358-14.363,12.111-22.891c12.615-39.064-8.825-80.958-47.894-93.572c-2.688-0.868-5.157-1.677-7.862-2.228 c1.686,3.097,2.411,6.768,2.411,10.553C395.567,231.313,385.051,241,373.584,241z M369.111,279.722c0,1.096-0.403,1.985-1.5,1.985 s-1.5-0.89-1.5-1.985v-6.615c0-1.095,0.403-1.984,1.5-1.984s1.5,0.89,1.5,1.984V279.722z M372.111,271.784v-2.646 c0-1.097,0.903-1.986,2-1.986c1.096,0,2,0.89,2,1.986v2.646c0,1.095-0.904,1.984-2,1.984 C373.015,273.769,372.111,272.879,372.111,271.784z M378.111,282.366c0,1.098-0.904,1.986-2,1.986s-2-0.889-2-1.986V278.4 c0-1.097,0.904-1.986,2-1.986s2,0.89,2,1.986V282.366z M382.111,277.076c0,1.096-0.404,1.984-1.5,1.984s-1.5-0.889-1.5-1.984 v-5.292c0-1.096,0.404-1.985,1.5-1.985s1.5,0.89,1.5,1.985V277.076z M438.111,299.568c0-1.096,0.904-1.986,2-1.986 s2,0.891,2,1.986v2.645c0,1.097-0.904,1.986-2,1.986s-2-0.89-2-1.986V299.568z M432.111,267.814c0-1.095,0.403-1.984,1.5-1.984 c1.096,0,1.5,0.89,1.5,1.984v5.292c0,1.097-0.404,1.984-1.5,1.984c-1.097,0-1.5-0.888-1.5-1.984V267.814z M432.111,298.244 c0-1.096,0.403-1.984,1.5-1.984c1.096,0,1.5,0.889,1.5,1.984v1.324c0,1.094-0.404,1.983-1.5,1.983c-1.097,0-1.5-0.89-1.5-1.983 V298.244z M432.111,306.182c0-1.095,0.403-1.982,1.5-1.982c1.096,0,1.5,0.888,1.5,1.982v5.293c0,1.095-0.404,1.984-1.5,1.984 c-1.097,0-1.5-0.89-1.5-1.984V306.182z M427.111,265.168c0-1.095,0.904-1.983,2-1.983c1.097,0,2,0.889,2,1.983v3.971 c0,1.095-0.903,1.983-2,1.983c-1.096,0-2-0.889-2-1.983V265.168z M425.111,274.432c0-1.098,0.904-1.986,2-1.986s2,0.889,2,1.986 v1.321c0,1.095-0.904,1.984-2,1.984s-2-0.89-2-1.984V274.432z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409670",
    d: "M328.111,242.678c0,1.095,1.404,1.984,2.5,1.984s2.5-0.89,2.5-1.984V241h-5V242.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409670",
    d: "M324.111,249.953c1.097,0,2-0.889,2-1.983v-1.322c0-1.098-0.903-1.985-2-1.985s-2,0.888-2,1.985v1.322 C322.111,249.064,323.015,249.953,324.111,249.953z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409670",
    d: "M329.611,248.632c-1.096,0-2.5,0.888-2.5,1.983v5.293c0,1.096,1.404,1.984,2.5,1.984 c1.097,0,2.5-0.889,2.5-1.984v-5.293C332.111,249.52,330.708,248.632,329.611,248.632z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409670",
    d: "M336.611,243.339c-1.096,0-1.5,0.89-1.5,1.984v2.646c0,1.095,0.404,1.983,1.5,1.983s1.5-0.889,1.5-1.983 v-2.646C338.111,244.229,337.707,243.339,336.611,243.339z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409670",
    d: "M322.111,271.784v-2.646c0-1.097-0.904-1.986-2-1.986c-1.097,0-2,0.89-2,1.986v2.646 c0,1.095,0.903,1.984,2,1.984C321.207,273.769,322.111,272.879,322.111,271.784z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409670",
    d: "M321.611,276.414c-1.096,0-1.5,0.89-1.5,1.986v2.646c0,1.094,0.404,1.983,1.5,1.983 c1.097,0,1.5-0.89,1.5-1.983V278.4C323.111,277.304,322.708,276.414,321.611,276.414z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409670",
    d: "M325.111,269.799c-1.097,0-2,0.89-2,1.985v2.647c0,1.094,0.903,1.982,2,1.982c1.096,0,2-0.889,2-1.982 v-2.647C327.111,270.688,326.207,269.799,325.111,269.799z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409670",
    d: "M366.111,311.475c0-1.095-1.404-1.984-2.5-1.984s-2.5,0.89-2.5,1.984v3.968c0,1.097,1.404,1.986,2.5,1.986 s2.5-0.89,2.5-1.986V311.475z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409670",
    d: "M369.111,314.783c-1.097,0-2,0.887-2,1.983v2.646c0,1.096,0.903,1.985,2,1.985s2-0.89,2-1.985v-2.646 C371.111,315.67,370.208,314.783,369.111,314.783z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409670",
    d: "M362.611,341.241c-1.096,0-2.5,0.891-2.5,1.985v2.646c0,1.096,1.404,1.984,2.5,1.984s2.5-0.889,2.5-1.984 v-2.646C365.111,342.132,363.707,341.241,362.611,341.241z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409670",
    d: "M367.611,337.274c-1.097,0-1.5,0.888-1.5,1.983v5.293c0,1.095,0.403,1.984,1.5,1.984s1.5-0.89,1.5-1.984 v-5.293C369.111,338.162,368.708,337.274,367.611,337.274z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409670",
    d: "M414.611,331.982c-1.096,0-2.5,0.888-2.5,1.982v2.647c0,1.095,1.404,1.984,2.5,1.984s2.5-0.89,2.5-1.984 v-2.647C417.111,332.87,415.707,331.982,414.611,331.982z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409670",
    d: "M410.111,335.949c-1.097,0-2,0.89-2,1.985v2.647c0,1.095,0.903,1.984,2,1.984c1.096,0,2-0.89,2-1.984 v-2.647C412.111,336.839,411.207,335.949,410.111,335.949z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M376.111,271.784v-2.646c0-1.097-0.904-1.986-2-1.986c-1.097,0-2,0.89-2,1.986v2.646 c0,1.095,0.903,1.984,2,1.984C375.207,273.769,376.111,272.879,376.111,271.784z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M380.611,269.799c-1.096,0-1.5,0.89-1.5,1.985v5.292c0,1.096,0.404,1.984,1.5,1.984s1.5-0.889,1.5-1.984 v-5.292C382.111,270.688,381.707,269.799,380.611,269.799z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M376.111,276.414c-1.096,0-2,0.89-2,1.986v3.966c0,1.098,0.904,1.986,2,1.986s2-0.889,2-1.986V278.4 C378.111,277.304,377.207,276.414,376.111,276.414z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M367.611,271.122c-1.097,0-1.5,0.89-1.5,1.984v6.615c0,1.096,0.403,1.985,1.5,1.985s1.5-0.89,1.5-1.985 v-6.615C369.111,272.012,368.708,271.122,367.611,271.122z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M429.111,271.122c1.097,0,2-0.889,2-1.983v-3.971c0-1.095-0.903-1.983-2-1.983c-1.096,0-2,0.889-2,1.983 v3.971C427.111,270.233,428.016,271.122,429.111,271.122z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M433.611,275.091c1.096,0,1.5-0.888,1.5-1.984v-5.292c0-1.095-0.404-1.984-1.5-1.984 c-1.097,0-1.5,0.89-1.5,1.984v5.292C432.111,274.203,432.515,275.091,433.611,275.091z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M427.111,277.737c1.096,0,2-0.89,2-1.984v-1.321c0-1.098-0.904-1.986-2-1.986s-2,0.889-2,1.986v1.321 C425.111,276.848,426.016,277.737,427.111,277.737z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M440.111,304.199c1.096,0,2-0.89,2-1.986v-2.645c0-1.096-0.904-1.986-2-1.986s-2,0.891-2,1.986v2.645 C438.111,303.31,439.016,304.199,440.111,304.199z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M433.611,313.459c1.096,0,1.5-0.89,1.5-1.984v-5.293c0-1.095-0.404-1.982-1.5-1.982 c-1.097,0-1.5,0.888-1.5,1.982v5.293C432.111,312.569,432.515,313.459,433.611,313.459z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC78B",
    d: "M433.611,301.552c1.096,0,1.5-0.89,1.5-1.983v-1.324c0-1.096-0.404-1.984-1.5-1.984 c-1.097,0-1.5,0.889-1.5,1.984v1.324C432.111,300.662,432.515,301.552,433.611,301.552z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebappOoops);
export default __webpack_public_path__ + "static/media/webapp_ooops.deb5a38198de56c4f8f50ee061e3f16c.svg";
export { ForwardRef as ReactComponent };